import publicRoutes from "./routes/public";

const app = () => {
  publicRoutes();
};

export default app;
